
import React, { useState, useEffect } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { LanguageSelector } from '@/components/LanguageSelector';
import { LoginForm } from '@/components/LoginForm';
import { RegisterForm } from '@/components/RegisterForm';
import { ForgotPasswordForm } from '@/components/ForgotPasswordForm';
import { TermsModal } from '@/components/TermsModal';
import { Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';

type AuthView = 'login' | 'register' | 'forgot-password';

const Index = () => {
  const {
    user,
    loading
  } = useAuth();
  const navigate = useNavigate();
  const [currentView, setCurrentView] = useState<AuthView>('login');
  const [showTerms, setShowTerms] = useState(false);

  console.log('Index page - user:', user, 'loading:', loading);

  useEffect(() => {
    if (!loading && user) {
      // If user exists and first_use is false, redirect to dashboard
      if (user.first_use === false) {
        navigate('/dashboard');
        return;
      }

      // If user exists but first_use is true or undefined, redirect to onboarding
      if (user.first_use === true || user.first_use === undefined) {
        navigate('/onboarding');
        return;
      }
    }
  }, [user, loading, navigate]);

  if (loading) {
    return <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin" />
      </div>;
  }

  // If user is logged in, we're handling redirects in useEffect
  // Show loading while redirect happens
  if (user) {
    return <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin" />
      </div>;
  }

  if (user) {
    return <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center space-y-4">
          <h1 className="text-3xl font-bold">¡Bienvenido a Clara!</h1>
          <p className="text-muted-foreground">Aplicación de gestión médica</p>
          <p className="text-sm">Usuario: {user.email}</p>
          <div className="space-y-2">
            <p className="text-xs text-muted-foreground">
              first_use: {user.first_use?.toString() || 'undefined'}
            </p>
            <Button onClick={() => navigate('/onboarding')}>
              Ir a Onboarding
            </Button>
          </div>
        </div>
      </div>;
  }

  return <div className="min-h-screen bg-white">
      <div className="container mx-auto px-4 py-8">
        
        
        <div className="flex items-center justify-center min-h-[calc(100vh-120px)]">
          <div className="w-full max-w-md">
            <div className="bg-card rounded-2xl p-8">
              <div className="mb-6 text-center">
                <div className="flex items-center justify-center mx-auto mb-4">
                  <img 
                    src="/lovable-uploads/c2ea4aaf-f672-4aef-9ac5-841554f64771.png" 
                    alt="Clara Logo" 
                    className="w-[230px] h-[100px] object-contain"
                  />
                </div>
              </div>

              {currentView === 'login' && <LoginForm onForgotPassword={() => setCurrentView('forgot-password')} onRegister={() => setCurrentView('register')} />}

              {currentView === 'register' && <RegisterForm onBack={() => setCurrentView('login')} onTerms={() => setShowTerms(true)} />}

              {currentView === 'forgot-password' && <ForgotPasswordForm onBack={() => setCurrentView('login')} />}
            </div>
          </div>
        </div>
      </div>

      <TermsModal open={showTerms} onClose={() => setShowTerms(false)} />
    </div>;
};

export default Index;
